import { render, staticRenderFns } from "./BaseEditButton.vue?vue&type=template&id=6d036a12&scoped=true&"
import script from "./BaseEditButton.vue?vue&type=script&lang=js&"
export * from "./BaseEditButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseEditButton.vue?vue&type=style&index=0&id=6d036a12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d036a12",
  null
  
)

export default component.exports